import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';

import ViewerComponent from './ViewerComponent';
import { getStackupLayers } from 'reducers';

const styles = theme =>({
  root: {
    height: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
  },
});

export class ViewerContainer extends Component {
  render() {
    const { classes, layers, match } = this.props;
    const { url } = match;

    return (
      <ViewerComponent
        classes={classes}
        layers={layers}
        url={url}
      />
    );
  }
}

function mapStateToProps(state){
  return {
    layers: getStackupLayers(state)
  }
}

ViewerContainer.propTypes = {
  classes:        PropTypes.object.isRequired,
  match:          PropTypes.object.isRequired,
  stackup:        PropTypes.object,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ViewerContainer);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ViewerContainer.js